const KeenSlider = window.KeenSlider

const { setInitialised, useArrows, useDots } = window.BAO.Carousel.plugins

class ProductMedia extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide?.exists) return
    if (this.els.slide.elements.length <= 1) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        mode: 'snap',
        rtl: true,
        slides: {
          perView: 1,
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 901px)': {
            slides: {
              perView: 1.1,
              spacing: 20,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 1.5,
              spacing: 20,
            },
          },
        },
      },
      [
        setInitialised(),
        useDots(this.els?.dot?.elements),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMedia)
}
